import { api } from '@/lib/api';

const urlBase64ToUint8 = (b64) => {
  const padding = '='.repeat((4 - (b64.length % 4)) % 4);
  const base64 = (b64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) out[i] = raw.charCodeAt(i);
  return out;
};

export const pushSupported = () =>
  'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

export const getPushPermission = () => (pushSupported() ? Notification.permission : 'unsupported');

export const enablePush = async () => {
  if (!pushSupported()) throw new Error('Push not supported by this browser');
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Permission denied');
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get('/push/vapid-public-key');
  let sub = await reg.pushManager.getSubscription();
  if (sub) {
    // re-subscribe if applicationServerKey changed (different VAPID key)
    try { await sub.unsubscribe(); } catch (_e) { /* ignore */ }
  }
  sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8(data.public_key),
  });
  await api.post('/push/subscribe', { subscription: sub.toJSON(), user_agent: navigator.userAgent });
  return true;
};

export const disablePush = async () => {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    try { await api.post('/push/unsubscribe', { subscription: sub.toJSON() }); } catch (_e) { /* ignore */ }
    await sub.unsubscribe();
  }
};
